import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mdc-button__ripple" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mdc-button__focus-ring" }, null, -1)
const _hoisted_3 = { class: "mdc-button__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_ctx.buttonClassName)
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}